var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-status"},[_c('span',{class:("table-circle " + _vm.bgc)}),_c('span',{class:("table-text " + _vm.color)},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }